// On-demand loading of secondary/hover product-card images (delegated version).
//
// product-block.liquid renders hover/alternate images as no-src placeholders
// (data-manual-src / data-manual-srcset via snippets/image.liquid 'manual' mode)
// when hover_manual is set. No download happens until first interaction.
//
// Listeners are delegated to <document> (mouseover/touchstart/focusin all
// bubble), so this keeps working even when the product grid renders or
// re-renders after DOMContentLoaded. The data-hover-loaded marker makes the
// load idempotent (only the first interaction per card pays for images).
document.addEventListener('DOMContentLoaded', function () {
  var SELECTOR = '.image-cont--with-secondary-image';

  function loadCardImages(card) {
    if (!card || card.getAttribute('data-hover-loaded')) return;
    card.setAttribute('data-hover-loaded', '1');
    var imgs = card.querySelectorAll('img[data-manual-src]');
    for (var i = 0; i < imgs.length; i++) {
      var el = imgs[i];
      if (el.getAttribute('data-manual-src')) el.src = el.getAttribute('data-manual-src');
      if (el.getAttribute('data-manual-srcset')) el.srcset = el.getAttribute('data-manual-srcset');
    }
  }

  function cardFrom(e) {
    return e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
  }

  // mouseenter does not bubble, but mouseover does -> delegate on mouseover.
  document.addEventListener('mouseover', function (e) { loadCardImages(cardFrom(e)); });
  document.addEventListener('touchstart', function (e) { loadCardImages(cardFrom(e)); }, { passive: true });
  document.addEventListener('focusin', function (e) { loadCardImages(cardFrom(e)); });
});
